import { render } from "./Notification_detail.vue?vue&type=template&id=6732a8c7&scoped=true"
import script from "./Notification_detail.vue?vue&type=script&lang=js"
export * from "./Notification_detail.vue?vue&type=script&lang=js"

import "./Notification_detail.vue?vue&type=style&index=0&id=6732a8c7&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6732a8c7"]])

export default __exports__